import { Color, Vector3 } from "three";
import { BasePanel } from "./BasePanel.js";
import VUtil from "../VUILib/VUtils.js";
import { HierarchyPanel } from "./HierarchyPanel.js";
import { SkyPanel } from "./SkyPanel.js";
import { VRSettingPanel } from "./VRSettingPanel.js";
import { MeasurePanel } from "./MeasurePanel.js";
import { BasicObjectCreatePanel } from "./BasicObjectCreatePanel.js";
import { SceneInfoPanel } from "./SceneInfoPanel.js";
import { EditPanel } from "./EditPanel.js";

const bgPath = "/assets/vrUI/mainPanel/bg.png";
const vrSettingPath = "/assets/vrUI/mainPanel/VR设置Icon.png";
const savePath = "/assets/vrUI/mainPanel/保存Icon.png";
const measurePath = "/assets/vrUI/mainPanel/测量Icon.png";
const scenePath = "/assets/vrUI/mainPanel/场景Icon.png";
const createPath = "/assets/vrUI/mainPanel/创建Icon.png";
const treePath = "/assets/vrUI/mainPanel/对象树Icon.png";
const skyPath = "/assets/vrUI/mainPanel/天空Icon.png";
const editPath = "/assets/vrUI/mainPanel/编辑Icon.png";

export class MainPanel extends BasePanel {
  constructor(manager) {
    super(manager);
  }

  async init() {
    const width = 0.55;
    const height = 1.2;

    // bg
    const bgMap = await this.manager.loadManager.loadTexture(bgPath);
    const bg = this.uilib.createContainer({
      color: 0x3d4146,
      map: bgMap,
      opacity: 1,
      width: width,
      height: height,
      radius: 0.02,
      dragable: false,
    });
    //bg.scale.set(0.5, 0.5, 0.5);
    this.uilib.addUIToScene(bg);

    bg.position.x += 1.225;
    bg.position.y += 0.4;

    this.uiElements.push(bg);

    // let worldCameraPos =
    //   this.manager.sceneManager.activeCamera.getWorldPosition(new Vector3());
    // let worldPos = bg.getWorldPosition(new Vector3());
    // let dir = worldCameraPos.sub(worldPos).normalize();
    // bg.lookAt(
    //   worldPos.add(dir.multiplyScalar(1000)) // 1000 是一个足够大的距离
    // );

    this.manager.interface.setClickMode(0); // 切换到默认模式

    this.items = [
      { path: editPath, name: "编辑" },
      { path: treePath, name: "对象树" },
      { path: skyPath, name: "天空" },
      { path: scenePath, name: "场景" },
      { path: vrSettingPath, name: "VR设置" },
      { path: createPath, name: "创建模型" },
      { path: measurePath, name: "测量" },
      { path: savePath, name: "保存" },
    ];

    for (var i = 0; i < this.items.length; i++) {
      await this.manager.loadManager.loadTexture(this.items[i].path, (tex) => {
        // icon
        const icon = this.uilib.createImage({
          map: tex,
          width: 0.1,
          height: 0.1,
          radius: 0,
          color: 0xafbbe3,
        });
        icon.position.x -= 0.12;

        // btn
        const item = this.uilib.createBtn({
          text: this.items[i].name,
          color: 0xffffff,
          opacity: 0.0,
          width: width * 0.8,
          height: 0.1,
          textSize: 0.045,
          textColor: 0xafbbe3, //0xafbbe3,
          radius: 0,
          align: "left",
          font: "bold",
          outlineWidth: 0.001,
        });
        item.addHoverEnterEvent((obj) => {
          icon.material.color = new Color("#ffffff");
          VUtil.setTextColor(obj.children[0], "#ffffff");
          VUtil.convertSRGBToLinear(icon.material);
        });
        item.addHoverExitEvent((obj) => {
          icon.material.color = new Color("#afbbe3");
          VUtil.setTextColor(obj.children[0], "#afbbe3");
          VUtil.convertSRGBToLinear(icon.material);
        });
        item.addClickEvent((obj) => {
          this.onClickBtn(obj);
        });
        bg.add(item);
        item.position.y = height / 2 - 0.11 - i * 0.14;
        item.position.z += 0.001;
        item.add(icon);
      });
    }

    this.hiararchyPanel = new HierarchyPanel(this.manager, false);
    this.skyPanel = new SkyPanel(this.manager, false);
    this.vrSettingPanel = new VRSettingPanel(this.manager, false);
    this.measurePanel = new MeasurePanel(this.manager, false);
    this.basicObjectCreatePanel = new BasicObjectCreatePanel(
      this.manager,
      false
    );
    this.sceneInfoPanel = new SceneInfoPanel(this.manager, false);
    this.editPanel = new EditPanel(this.manager, false);
    
    // 将地形编辑面板添加到VRManager中，以便在VR模式下使用
    this.manager.vrManager.terrainPanel = this.editPanel.terrainPanel;
    console.log(this.editPanel);
  }

  onClickBtn(obj) {
    const tagName = obj.name.split("_")[1];

    switch (tagName) {
      case "编辑":
        if (this.editPanel && !this.editPanel.enabled) {
          if (this.measurePanel && this.measurePanel.enabled)
            this.measurePanel.closePanel(); // 编辑面板与测量面板不能同时打开
          if (this.vrSettingPanel && this.vrSettingPanel.enabled)
            this.vrSettingPanel.closePanel(); // 编辑面板与VR设置面板不能同时打开
          if (
            this.basicObjectCreatePanel &&
            this.basicObjectCreatePanel.enabled
          )
            this.basicObjectCreatePanel.closePanel(); // 编辑面板与创建模型面板不能同时打开

          this.editPanel.show();
        }
        break;
      case "对象树":
        if (this.hiararchyPanel && !this.hiararchyPanel.enabled)
          this.hiararchyPanel.show();
        break;
      case "天空":
        if (this.skyPanel && !this.skyPanel.enabled) this.skyPanel.show();
        break;
      case "场景":
        if (this.sceneInfoPanel && !this.sceneInfoPanel.enabled)
          this.sceneInfoPanel.show();
        break;
      case "VR设置":
        if (this.vrSettingPanel && !this.vrSettingPanel.enabled) {
          if (this.measurePanel && this.measurePanel.enabled)
            this.measurePanel.closePanel(); //VR设置面板与测量面板不能同时打开
          if (this.editPanel && this.editPanel.enabled)
            this.editPanel.closePanel(); // 编辑面板与VR设置面板不能同时打开
          if (
            this.basicObjectCreatePanel &&
            this.basicObjectCreatePanel.enabled
          )
            this.basicObjectCreatePanel.closePanel(); // 编辑面板与创建模型面板不能同时打开
          this.vrSettingPanel.show();
        }
        break;
      case "创建模型":
        if (
          this.basicObjectCreatePanel &&
          !this.basicObjectCreatePanel.enabled
        ) {
          if (this.editPanel && this.editPanel.enabled)
            this.editPanel.closePanel(); // 编辑面板与测量面板不能同时打开
          if (this.vrSettingPanel && this.vrSettingPanel.enabled)
            this.vrSettingPanel.closePanel(); // 测量面板与VR设置面板不能同时打开
          if (this.measurePanel && this.measurePanel.enabled)
            this.measurePanel.closePanel(); // 编辑面板与创建模型面板不能同时打开

          this.basicObjectCreatePanel.show();
        }
        break;
      case "测量":
        if (this.measurePanel && !this.measurePanel.enabled) {
          if (this.editPanel && this.editPanel.enabled)
            this.editPanel.closePanel(); // 编辑面板与测量面板不能同时打开
          if (this.vrSettingPanel && this.vrSettingPanel.enabled)
            this.vrSettingPanel.closePanel(); // 测量面板与VR设置面板不能同时打开
          if (
            this.basicObjectCreatePanel &&
            this.basicObjectCreatePanel.enabled
          )
            this.basicObjectCreatePanel.closePanel(); // 编辑面板与创建模型面板不能同时打开
          this.measurePanel.show();
        }
        break;
      case "保存":
        this.manager.interface.save((info) => {
          this.vrManager.makeSystemTip(info, 3000);
        });
        break;
    }
  }

  //  --------------------------------------接口函数，给外部调用
  /**
   * 场景模型模式选中模型
   * @param {*} model
   */
  setSelectModel(model) {
    if (this.editPanel) this.editPanel.setSelectModel(model);
  }

  updateModelValue() {
    if (this.editPanel) this.editPanel.updateModelValue();
  }

  /**
   * 模型库模式选中场景中的材质
   * @param {*} material
   */
  setSelectMaterial(material) {
    if (this.editPanel) this.editPanel.setSelectMaterial(material);
  }

  /**
   * 由于增加或删除模型导致更新结构树
   * @param {*} ids 节点的nodeId数组
   * @param {*} order "delete"/"add"
   * @param {*} parentId 父节点id，设置为null表示添加到最外层
   */
  updateHierarchy(ids, order, parentId = null) {
    if (this.hiararchyPanel)
      this.hiararchyPanel.updateHierarchy(ids, order, parentId);
  }

  /**
   * 选中结构树上的一些节点
   * @param {*} model
   */
  selectHiarerchyNodes(ids) {
    if (this.hiararchyPanel) this.hiararchyPanel.selectSomeNode(ids);
  }

  /**
   * 设置结构树是否可以点击 只有在场景模型模式和材质库模式下才能点击结构树
   * @param {*} enable
   */
  setHierarchyNodeClickable(enable) {
    if (this.hiararchyPanel)
      this.hiararchyPanel.setHierarchyNodeClickable(enable);
  }

  /**
   * 打开编辑面板
   * @param {*} subPanel 子面板 "None"/"sceneModel"/"Terrain"/"Material"/"Model"/"Way"
   */
  openEditPlane(subPanel = "None") {
    if (this.editPanel) {
      if (this.measurePanel) this.measurePanel.closePanel(); // 编辑面板与测量面板不能同时打开
      if (this.vrSettingPanel) this.vrSettingPanel.closePanel(); // 编辑面板与VR设置面板不能同时打开

      this.editPanel.show(subPanel);
    }
  }

  /**
   * 更新测量面板数据
   * @param {*} records
   */
  updateMeasureRecords(records) {
    if (this.measurePanel) this.measurePanel.updateRecords(records);
  }

  setModellibDefault() {
    if (this.editPanel) this.editPanel.setModellibDefault();
  }
}
